<template>
  <div></div>
</template>

<script>
  import { notification, Button } from 'ant-design-vue';
  import { h } from 'vue';
  import {useRouter} from "vue-router";
  import {onBeforeMount} from "@vue/runtime-core";
  import {computed} from "@vue/reactivity";
  import {useStore} from "vuex";
  export default {
    setup() {

      const router = useRouter();
      const store = useStore();

      const personalActivity = computed(() => store.state.personalActivity);

      const openNotification = (code) => {
        const key = `open${Date.now()}`;
        notification.open({
          message: 'Напоминание о тестировании',
          duration: 0,
          description:
              'Вы не завершили тестирование. Не забудьте пройти его.',
          btn: () =>
              h(
                  Button,
                  {
                    class: 'primary-button',
                    onClick: () => {
                      notification.close(key);
                      router.push('/passing/' + code);
                    },
                  },
                  { default: () => 'Открыть' },
              ),
          key,
        });
      };

      onBeforeMount(() => {
        store.dispatch('getPersonalActivity').then(() => {
          const firstUnfinished = personalActivity.value.passings?.find(
              (p) => p.status !== "finished"
          );

          if (firstUnfinished) {
            openNotification(firstUnfinished.code);
          }
        });
      });
    }
  }
</script>